<app-modal>
	<div modal-header>
		<span i18n="Modal Titel for Login@@login.modal.title">Login</span>
	</div>
	<div modal-body>
		<form [formGroup]="loginForm">
			<div class="form-group">
				<label>Email address</label>
				<input type="email" formControlName="email" class="form-control">
			</div>
			<div class="form-group">
				<label>Password</label>
				<input type="password" class="form-control" formControlName="password">
				<label class="error">{{errorMessage}}</label>
			</div>
			<button type="submit" (click)="tryLogin(loginForm.value)" class="btn btn-default">Login</button>
		</form>
	</div>
</app-modal>